import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const createPracticeCallLink = (payload, botId, callback) => {
  return async (dispatch) => {
    dispatch({ type: 'CREATING_LINK_FOR_PRACTICE_CALL' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.post(
            `/ads/bots/${botId}/conversations/link-token`,
            payload,
            {
              params: {
                'request-id': reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'plain/text',
                // 'x-api-version': 'v2',
              },
            },
          );
          if (response.status === 200) {
            await dispatch({
              type: 'CREATING_LINK_FOR_PRACTICE_CALL_DONE',
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'CREATING_LINK_FOR_PRACTICE_CALL_FAILED',
              payload: `Failed to create new practice call link`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'CREATING_LINK_FOR_PRACTICE_CALL_FAILED',
            payload: `Failed to create new practice call link`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'CREATING_LINK_FOR_PRACTICE_CALL_FAILED',
        payload: `Failed to create new practice call link`,
      });
    }
  };
};

export default createPracticeCallLink;
